import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Metatag from "../../hooks/Metatag";
import globalVariables from "../../global-variables";
import axios from "axios";

export default function FocusAreas1() {
  const [focusAreaList, setFocusAreaList] = useState(null);

  useEffect(() => {
    // remove bg-header-home
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [focusAreaList]);

  useEffect(() => {
    let _obj = new Object();
    _obj.focus_ar_status = 1;
    _obj.mapped_focus_ar = 'Y';

    axios
      .post(
        globalVariables.variables.strApiUrl + "/focusAreaApi/getFocusAreaList",
        _obj
      )
      .then((response) => {
        setFocusAreaList(response.data[0]);
      });
  }, []);
  
  return (
    <>
      <Header></Header>

      <Metatag
        title="Green Energy Research Programs | Battery Technologies Research Programs | Bio Fuels Research Programs | Sustainability Research Programs"
        description="Sustainable Energy Research Programs like Green Energy, Green Hydrogen, Battery Technologies, Bio Fuels offered by IIT Bombay"
        keywords="Sustainability Energy Research Programs, Green Energy Research Programs, Battery Technologies Research Programs, Bio Fuels Research Programs, Sustainable Energy Research Programs at IIT Bombay"
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0">
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Focus Areas
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="my-5 pt-4 pt-xl-5">
        <Row className="gx-1 row-cols-1 row-cols-md-2 row-cols-xl-3 g-lg-4 g-xxl-5 g-4 overflow-hidden">
          {focusAreaList !== null ? (
            focusAreaList.map((focusArea, index) => {
              return (
                <Col key={index}>
                  <Row className="g-0 position-relative overflow-hidden h-100">
                    <Col md={4} className="container-start z-3 d-md-block d-none">
                      <div>
                        <div className="border-bottom border-4 border-primary rounded-4 overflow-hidden text-center bg-white wow fadeInUp">
                          <div className="bg-primary bg-opacity-10 rounded-4 border p-md-4 px-5 wow fadeInUp">
                            <div className="position-relative overflow-hidden d-flex align-items-center justify-content-center">
                              {/* <img
                                src={`${global.variables.strDomainUrl}images/research-icon.png`}
                                alt=""
                                title=""
                                className="img-fluid wow fadeInUp"
                              /> */}
                              <img
                                src={`${global.variables.strApiUrl}/focus-area/${focusArea.focus_ar_icon}`}
                                alt={focusArea.focus_ar_name}
                                title={focusArea.focus_ar_name}
                                className="img-fluid pic-focusarea wow fadeInUp"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col md={9}>
                      <div className="border rounded-4 ps-md-5 pe-md-4 py-md-4 h-100">
                        <div className="col-md-11 ms-auto">
                          <div className="mb-4 d-md-none d-block border-bottom border-4 border-primary rounded-4 overflow-hidden wow fadeInUp">
                            <div className="bg-primary bg-opacity-10 rounded-4 border p-md-4 px-5 py-4 text-center wow fadeInUp">
                              <img
                                src={`${global.variables.strApiUrl}/focus-area/${focusArea.focus_ar_icon}`}
                                alt={focusArea.focus_ar_name}
                                title={focusArea.focus_ar_name}
                                className="img-fluid px-5 px-md-0 wow fadeInDown"
                              />
                            </div>
                          </div>
                          <div className="px-3 pb-3 px-md-0 text-center text-md-start">
                            <h6 className="wow fadeInUp">
                              {focusArea.focus_ar_name}
                            </h6>
                            {focusArea.focus_ar_desc !== null &&
                              focusArea.focus_ar_desc !== "" ? (
                              <p
                                className="wow fadeInUp"
                                dangerouslySetInnerHTML={{
                                  __html: focusArea.focus_ar_desc,
                                }}
                              ></p>
                            ) : null}
                            {focusArea.map_focus_area_count > 0 ? (
                              <Link
                                to={"/research-projects/search-result"}
                                state={{
                                  focusAreaId: focusArea.focus_ar_id,
                                  focusAreaName: focusArea.focus_ar_name,
                                  facultyId: null,
                                  faculty_name: null,
                                  sdg_id: null,
                                  sdg_name: null,
                                  resStr: null,
                                  resType: global.variables.strSustainabilityResearchAtIITB_id,
                                }}
                                className="btn btn-primary rounded-pill px-4 mt-2 wow fadeInUp"
                              >
                                View Projects
                              </Link>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              );
            })
          ) : (
            <Container className="mb-5 pt-5 news-details">
              <Row>
                <span className="text-center">Loading...</span>
              </Row>
            </Container>
          )}
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Focus Areas</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
